import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import {db} from '../../firebase';

class StreetTeamPayouts extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isLoading: true,
      streetTeamPayouts: null
    }
  }

  componentDidMount = () => {
    const {userId} = this.props;

    db
    .collection('streetTeamPayouts')
    .where('userId', '==', userId)
    .orderBy('createdAt', 'desc')
    .onSnapshot((payoutsSnapshot) => {
      this.setState({
        isLoading: false,
        streetTeamPayouts: payoutsSnapshot.docs,
      })
    });
  }

  render() {
    const {streetTeamPayouts, isLoading} = this.state;

    if (isLoading) {
      return (
        <div>
          Loading payouts...
        </div>
      )
    }

    return (
      <div>
        <h3>Payouts</h3>

        <div className='table-responsive my-2'>
          <table className='table'>
            <thead>
              <tr>
                <td>Payout ID</td>
                <td>Created At</td>
                <td>Amount</td>
                <td>Description</td>
                <td>Stripe Transfer Id</td>
                <td>Instant</td>
                <td>Stripe Payout Id</td>
              </tr>
            </thead>

            <tbody>
              {streetTeamPayouts.map((payout) => {
                const {id: payoutId} = payout;
                const {
                  stripeTransferId, amount, createdAt, description, stripeTransferInstant,
                  stripePayoutId
                } = payout.data();

                return (
                  <tr key={payoutId}>
                    <th scope="row">
                      {payoutId}
                    </th>
                    <td>
                      {moment(createdAt.toDate()).fromNow()}
                    </td>
                    <td >
                      {amount}
                    </td>
                    <td>
                      {description}
                    </td>
                    <td>
                      <a href={`https://dashboard.stripe.com/applications/transfers/${stripeTransferId}`}>
                        {stripeTransferId}
                      </a>
                    </td>
                    <td>
                      {stripeTransferInstant}
                    </td>
                    <td>
                      {stripePayoutId}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

StreetTeamPayouts.propTypes = {
  userId: PropTypes.string.isRequired,
}

export {StreetTeamPayouts};



// WEBPACK FOOTER //
// ./src/street-team/member-profile/StreetTeamPayouts.js